import { render, staticRenderFns } from "./UpgradeEnquire.vue?vue&type=template&id=055024c5&scoped=true&"
import script from "./UpgradeEnquire.vue?vue&type=script&lang=js&"
export * from "./UpgradeEnquire.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeEnquire.vue?vue&type=style&index=0&id=055024c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055024c5",
  null
  
)

export default component.exports